import React from 'react';
import { Dialog, DialogContent, Typography, Box, IconButton } from '@mui/material';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import CloseIcon from '@mui/icons-material/Close';

const RotateScreenDialog = ({ 
    open, 
    onClose, 
    title = "Rotate Your Device",
    message = "Please rotate your device to landscape mode to access this function"
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen
            sx={{
                '& .MuiDialog-paper': {
                    backgroundColor: '#1976d2',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                    position: 'relative'
                }
            }}
        >
            {/* Close Button - Top Right */}
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    color: 'white',
                    '&:hover': {
                        transform: 'scale(1.1)'
                    },
                    transition: 'all 0.3s ease',
                    zIndex: 1
                }}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent sx={{ textAlign: 'center', color: 'white' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 3
                    }}
                >
                    {/* Rotating Phone Animation */}
                    <Box
                        sx={{
                            position: 'relative',
                            width: 80,
                            height: 120,
                            border: '3px solid white',
                            borderRadius: '12px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            animation: 'rotatePhone 2s ease-in-out infinite',
                            '@keyframes rotatePhone': {
                                '0%': {
                                    transform: 'rotate(0deg)',
                                },
                                '50%': {
                                    transform: 'rotate(90deg)',
                                },
                                '100%': {
                                    transform: 'rotate(0deg)',
                                }
                            }
                        }}
                    >
                        <RotateLeftIcon
                            sx={{
                                fontSize: 40,
                                color: 'white',
                                animation: 'pulse 1.5s ease-in-out infinite',
                                '@keyframes pulse': {
                                    '0%, 100%': {
                                        opacity: 1,
                                        transform: 'scale(1)'
                                    },
                                    '50%': {
                                        opacity: 0.7,
                                        transform: 'scale(1.1)'
                                    }
                                }
                            }}
                        />
                    </Box>

                    {/* Message */}
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 'bold',
                            marginBottom: 1,
                            color: 'white',
                            // textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            opacity: 0.9,
                            maxWidth: '300px',
                            lineHeight: 1.5,
                            color: 'white',
                            // textShadow: '0 1px 2px rgba(0,0,0,0.3)'
                        }}
                    >
                        {message}
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default RotateScreenDialog; 